// extracted by mini-css-extract-plugin
export default {"warning":"uvg4o__warning","error":"viIRr__error","lightText":"BUdTJ__lightText"};